import { render, staticRenderFns } from "./word-tq-source-block.vue?vue&type=template&id=e4cca030&"
import script from "./word-tq-source-block.vue?vue&type=script&lang=js&"
export * from "./word-tq-source-block.vue?vue&type=script&lang=js&"
import style0 from "./word-tq-source-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e4cca030', component.options)
    } else {
      api.reload('e4cca030', component.options)
    }
    module.hot.accept("./word-tq-source-block.vue?vue&type=template&id=e4cca030&", function () {
      api.rerender('e4cca030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/word-list/word-tq-source-block.vue"
export default component.exports